export const useStyles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 10,
  },
  title: {
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  iconStyle: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  body: { width: "100%" },
});
